


export const getDynamicHeight = () : number => {
    const { innerHeight,  innerWidth  } = window
    const aspectRatio = innerHeight / innerWidth;
    return Math.floor(375 * aspectRatio);
} 
export const getDynamicVisualViewport = () : number | string => {

    const visualViewport = window?.visualViewport as VisualViewport

    if (visualViewport != null) {
        const aspectRatio = visualViewport.height / innerWidth;
        return Math.floor(375 * aspectRatio);
    }  else {
        return 100
    }
} 

